import { InputLabel } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';

export default withStyles({
  root: {
    zIndex: 1,
  }
})(InputLabel);